var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var Input_1 = __importDefault(require("./Input"));
exports.Input = Input_1.default;
exports.default = Input_1.default;
//# sourceMappingURL=index.js.map